export default __webpack_public_path__ + "static/media/fabula_mob_banner_2.7478f44c.png";